import { createAsyncThunk } from '@reduxjs/toolkit';
import { _studyResearchUrls } from '@custom/Utils/constants/apiUrls';

 const addStudyResearch = createAsyncThunk(
  'studyResearch/addStudyResearch',
  async (payload, { rejectWithValue }) => {
    const url = _studyResearchUrls.add;
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to add research data. Status code: ${response?.status}`);
      }

      return await response.json();

    } catch (error) {
      return rejectWithValue(`Failed to add research data. Status code: ${error}`);
    }
  }
);

export default addStudyResearch;
